import { useEffect } from 'react';
import { CheckCircle, XCircle, AlertTriangle, Info, X } from 'lucide-react';
import { useUIStore } from '../../store';
import { cn } from '../../lib/utils';

const ICONS = {
  success: CheckCircle,
  error:   XCircle,
  warn:    AlertTriangle,
  info:    Info,
};

const STYLES = {
  success: 'border-bull/40 bg-bg-surface lg:bg-bull/10 lg:border-bull/30 text-bull',
  error:   'border-bear/40 bg-bg-surface lg:bg-bear/10 lg:border-bear/30 text-bear',
  warn:    'border-warn/40 bg-bg-surface lg:bg-warn/10 lg:border-warn/30 text-warn',
  info:    'border-info/40 bg-bg-surface lg:bg-info/10 lg:border-info/30 text-info',
};

function Toast({ id, type = 'info', message }) {
  const { removeToast } = useUIStore();
  const Icon = ICONS[type] || Info;

  useEffect(() => {
    const t = setTimeout(() => removeToast(id), 4000);
    return () => clearTimeout(t);
  }, [id, removeToast]);

  return (
    <div
      className={cn(
        'flex items-start gap-3 px-4 py-3 rounded-lg border text-sm font-mono',
        'shadow-panel animate-fade-in min-w-[280px] max-w-sm',
        STYLES[type]
      )}
    >
      <Icon size={14} className="shrink-0 mt-0.5" />
      <span className="flex-1 min-w-0 break-words text-txt-primary text-xs">{message}</span>
      <button onClick={() => removeToast(id)} className="opacity-60 hover:opacity-100">
        <X size={12} />
      </button>
    </div>
  );
}

export default function ToastContainer() {
  const { toasts } = useUIStore();
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-20 inset-x-4 flex flex-col gap-2 z-[2000] lg:top-auto lg:inset-x-auto lg:bottom-6 lg:right-6"
    >
      {toasts.map((t) => <Toast key={t.id} {...t} />)}
    </div>
  );
}
